
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 165.001 165.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"shp0",attrs:{"d":"M55.3 127.1l-17.1.8c-1.1 0-2.1-.9-2-2l.8-17.1c.1-1.5.7-2.8 1.7-3.9l64-64 20.6 20.6-64 64c-1.1.9-2.5 1.5-4 1.6zM127.6 57L107 36.4l5.7-5.7c2.3-2.3 6.1-2.3 8.5 0l12.1 12.1c2.3 2.3 2.3 6.1 0 8.5l-5.7 5.7z"}})])
          )
        }
      }
    